import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import duplicateScheduledReport from "api/scheduledReports/duplicateScheduledReport";
import handleInvalidateError from "helpers/handleInvalidateError";
import { scheduledReportsKey } from "queryKeys/scheduledReportsKey";

export default function useDuplicateScheduledReportMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: duplicateScheduledReport,
    onSuccess: (data) => {
      toast.success(data?.message || "Scheduled Report duplicated successfully!");

      queryClient
        .invalidateQueries({ queryKey: scheduledReportsKey() })
        .catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to duplicate report.");
    },
  });
}
